<script>
export default {
    props: {
        value: {
            type: Object,
            default: null,
        },

        minPlaceholder: {
            type: String,
            default: 'Min',
        },

        maxPlaceholder: {
            type: String,
            default: 'Max',
        },
    },

    methods: {
        onInput() {
            this.$emit('input', {
                min: this.$refs.minInput.value,
                max: this.$refs.maxInput.value,
            });
        },
    },
};
</script>

<template>
    <div class="input-group">
        <input
            ref="minInput"
            type="text"
            :placeholder="minPlaceholder"
            class="form-control"
            :value="value.min"
            @input="onInput"
        >
        <span class="input-group-addon">to</span>
        <input
            ref="maxInput"
            type="text"
            :placeholder="maxPlaceholder"
            class="form-control"
            :value="value.max"
            @input="onInput"
        >
    </div>
</template>
